import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useHover } from 'ahooks';
import { cloneElement, isValidElement, useRef, useState } from 'react';
import { classNames } from '../../common/utils/classnames';
import Next from '../icons/next';
import Prev from '../icons/prev';
import { useMobile } from '../../common/hooks/use-mobile';
export var Navigation = function Navigation(props) {
  var className = props.className,
    arrowClassName = props.arrowClassName,
    navigation = props.navigation,
    arrow = props.arrow,
    children = props.children;
  var _useState = useState(),
    swiper = _useState[0],
    setSwiper = _useState[1];
  var wrapRef = useRef(null);
  var hovering = useHover(wrapRef);
  var mobile = useMobile();
  /** https://jira.co-mall.com/browse/DCH-7264 mobile暂时隐藏轮播切换箭头按钮 */
  var navigating = navigation && (arrow === 'show' || arrow === 'hover' && hovering) && !mobile;
  return _jsx("div", Object.assign({
    className: classNames('relative w-full h-full', className),
    ref: wrapRef
  }, {
    children: _jsxs(_Fragment, {
      children: [navigating && _jsx("button", Object.assign({
        className: classNames('absolute left-2 z-2 w-6 h-6 outline-none', 'cq-pc:w-15 cq-pc:h-15', arrowClassName),
        style: {
          top: '50%',
          transform: 'translateY(-50%)'
        },
        onClick: function onClick() {
          return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
        }
      }, {
        children: _jsx(Prev, {
          className: 'w-full h-full text-white drop-shadow-dark'
        })
      })), /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, {
        // @ts-ignore
        onSwiper: function onSwiper(swiper) {
          var _a, _b;
          (_b = (_a = children.props).onSwiper) === null || _b === void 0 ? void 0 : _b.call(_a, swiper);
          setSwiper(swiper);
        }
      }) : children, navigating && _jsx("button", Object.assign({
        className: classNames('absolute right-2 z-2 w6- h-6 outline-none', 'cq-pc:w-15 cq-pc:h-15', arrowClassName),
        style: {
          top: '50%',
          transform: 'translateY(-50%)'
        },
        onClick: function onClick() {
          return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
        }
      }, {
        children: _jsx(Next, {
          className: 'w-full h-full text-white drop-shadow-dark'
        })
      }))]
    })
  }));
};